import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import onClickOutside from 'react-onclickoutside';
import * as userActions from '../../actions/userActions';
import LoginView from '../../components/Customer/Auth/LoginView';
import RegisterView from '../../components/Customer/Auth/RegisterView';
import ConfirmView from '../../components/Helpers/ConfirmView';
import ForgotView from "../../components/Customer/Auth/ForgotView";
import PropTypes from 'prop-types';
import {actionWrapper, clickOutsideConfig} from '../../helpers';
import {translate} from 'react-i18next';
import classNames from 'classnames';
import {withRouter} from 'react-router-dom';


class AuthModalLayout extends Component {
  constructor(props) {
    super(props);

    this.authUser = this.authUser.bind(this);
    this.registerUser = this.registerUser.bind(this);
    this.forgotPassword = this.forgotPassword.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.clearError = this.clearError.bind(this);
    this.state = {
      errors: {},
      type: 'login',
      inProgress: false,
      confirm: {}
    };
  }

  authUser(data) {
    actionWrapper(this, data, this.props.authUser).then(this.closeModal);
  }

  registerUser(data) {
    actionWrapper(this, data, this.props.registerUser).then(() => {
      this.openConfirm('create', true, this.closeModal);
    });
  }

  forgotPassword(data) {
    actionWrapper(this, data, this.props.forgotPassword).then(() => {
      this.openConfirm('forgot', true, () => this.updateType('login'));
    });
  }

  openConfirm(action, success = true, callback) {
    this.setState({
      type: 'confirm',
      confirm: {
        success: success,
        action: action,
        onConfirm: callback
      }
    })
  }

  updateType(type) {
    this.setState({
      type: type,
      errors: {}
    });
  }

  handleClickOutside() {
    this.closeModal();
  };

  closeModal() {
    this.props.closeAuthModal();
  }

  clearError() {
    this.setState({
      errors: {},
    });
  }

  render() {
    const {inProgress, errors, type, confirm} = this.state;
    const {language} = this.props;
    const error = errors.error || [];
    return (
      <div className={classNames('login__form', {'login__form--register' : type === 'register'})}>
        <button
          type='button'
          className="login__close-btn"
          onClick={this.closeModal}
        />

        {type === 'login' &&
          <LoginView
            inProgress={inProgress}
            action={this.authUser}
            onRegister={() => this.updateType('register')}
            onForgot={() => this.updateType('forgot')}
            errors={error}
            clearError={this.clearError}
          />
        }

        {type === 'register' &&
          <RegisterView
            inProgress={inProgress}
            action={this.registerUser}
            errors={errors}
            onCancel={() => this.updateType('login')}
            language={language}
          />
        }

        {type === 'forgot' &&
          <ForgotView
            inProgress={inProgress}
            errors={error}
            action={this.forgotPassword}
            onCancel={() => this.updateType('login')}
            clearError={this.clearError}
          />
        }

        {type === 'confirm' &&
          <ConfirmView
            config={confirm}
          />
        }
      </div>
    );
  }
}

AuthModalLayout.propTypes = {
  closeAuthModal: PropTypes.func,
  authUser: PropTypes.func.isRequired,
  registerUser: PropTypes.func.isRequired,
  forgotPassword: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    language: state.language.defaultLanguage,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    closeAuthModal: bindActionCreators(userActions.closeAuthModal, dispatch),
    authUser: bindActionCreators(userActions.loginUser, dispatch),
    registerUser: bindActionCreators(userActions.registerUser, dispatch),
    forgotPassword: bindActionCreators(userActions.forgotPassword, dispatch),
  };
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(translate('translations')(
  onClickOutside(AuthModalLayout, clickOutsideConfig))));




// WEBPACK FOOTER //
// ./src/containers/Customer/AuthModal.js